import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ClubServicesService } from '../../services/club-services.service';
import { PlayerServicesService } from '../../services/players-services.service';

@Component({
  selector: 'app-cancel-order-dialogue',
  templateUrl: './cancel-order-dialogue.component.html',
  styleUrls: ['./cancel-order-dialogue.component.scss']
})
export class CancelOrderDialogueComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private csObj: CommonService,
    private toast: ToastrService,
    private router: Router,
    private dialogRef: MatDialog,
    private auth: AuthService,
    private spinner: SpinnerVisibilityService,
    private clubService: ClubServicesService,
    private playerService: PlayerServicesService
  ) { }

  orderId: any;
  currentUser: any;
  defaultImage = '../../../../assets/icons/Loading_icon.gif';

  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);
  }

  // Delete teams functionality
  DeletBtnClick() {
    try {
      this.csObj.deleteAPI(this.data.userType.id).subscribe((res: any) => {
        console.log(this.data.userType.id);
        this.toast.success("Team Deleted successfully");
        let currentURL = this.router.url
        this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentURL]);
        });

      },
        (err: any) => {
          this.toast.error(err.message);
        })
    }
    catch (e) { }
  }


  // logout  functionality
  logoutClick() {
    this.orderId = localStorage.getItem('orderId');
    // alert(id);
    // this.csObj.cancelOrder$.subscribe((id:any)=>{
    //   alert('2'+id)
    // })

    if (this.currentUser?.userDetails?.userType === 3 || this.currentUser.userType == 3) {
      this.playerService.playerCancelOrder(this.orderId).subscribe((res: any) => {
        if (res.status == 200) {
          const route = this.router.url;
          if (route.includes('/manage_Orders')) {
            this.router.navigate(['/manage_Orders']);
          } else {
            this.router.navigate(['/manageOrders']);
          }
          // this.toast.success("Order Canceled");
          console.log(this.data.userType.text);
          if (this.data.userType.text)
            this.toast.success(this.data.userType.text);
        }
      })
    } else {
      this.clubService.cancelOrder(this.orderId).subscribe((res: any) => {
        if (res.status == 200) {
          const route = this.router.url;
          if (route.includes('/manage_Orders')) {
            this.router.navigate(['/manage_Orders']);
          } else {
            this.router.navigate(['/manageOrders']);
          }
          // this.toast.success("Order Canceled");
          console.log(this.data.userType.text);
          if (this.data.userType.text)
            this.toast.success(this.data.userType.text);
        }
      })
    }
  }

}
